import { render, staticRenderFns } from "./PrintExtractionDialog.vue?vue&type=template&id=6ba4a5e8&"
import script from "./PrintExtractionDialog.vue?vue&type=script&lang=js&"
export * from "./PrintExtractionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports